import React, { useState, useEffect } from "react";
import { Plus } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import apiService from "../../services/apiService";
import { toast } from "react-toastify";

const EditRadioFile = () => {
  const navigate = useNavigate();
  const { radio_audio_file_id } = useParams(); // Get ID from URL

  const [content, setContent] = useState({
    file_path: "",
    duration: "",
  });

  useEffect(() => {
    if (radio_audio_file_id) {
      fetchSlot();
    }
  }, [radio_audio_file_id]);

  const fetchSlot = async () => {
    try {
      const res = await apiService.fetchData(`admin/radio-file-path/${radio_audio_file_id}`);
      if (!res.error && res.data) {
        setContent({
          file_path: res.data.file_path || "",
          duration: res.data.duration || "",
        });
      }
    } catch (err) {
      toast.error("Error fetching radio file.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContent({ ...content, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in content) {
      formData.append(key, content[key]);
    }

    try {
      await apiService.putData(`admin/radio-file-path/${radio_audio_file_id}`, formData);
      toast.success("Radio file updated successfully!");
      navigate("/radio/file");
    } catch (error) {
      console.error("Error updating radio file:", error);
      toast.error("Error updating radio file.");
    }
  };

  return (
    <div className="row">
      <div className="col-12 col-md-12">
        <div className="card">
          <div className="card-header">
            <h4>Edit Radio File</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>File Path</label>
                <input
                  type="text"
                  name="file_path"
                  className="form-control"
                  value={content.file_path}
                  onChange={handleChange}
                  placeholder="Enter File Path"
                />
              </div>

              {/* <div className="form-group">
                <label>Duration</label>
                <input
                  type="text"
                  name="duration"
                  className="form-control"
                  value={content.duration}
                  onChange={handleChange}
                  placeholder="Enter Duration (seconds)"
                />
              </div> */}

              <div className="d-flex gap-2 mt-3">
                <button type="submit" className="btn btn-primary">
                  <Plus size={16} /> Update
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate("/radio/file")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditRadioFile;
